import ListingFilterItem from '@atoms/ListingFilterItem/ListingFilterItem';
import ListingTypeEnum from '@models/enums/ListingTypeEnum';
import { IListingFilterGroup } from '@models/IListing';
import classNames from 'classnames';

interface Props {
  readonly filters: IListingFilterGroup[];
  readonly isMobileFilters?: boolean;
  readonly onClickCallback: (
    selectedListingFilters: IListingFilterGroup[],
  ) => void;
  readonly selectedListingFilters?: string[];
  readonly type?: ListingTypeEnum;
}

const ListingFilters = ({
  filters,
  type = ListingTypeEnum.Colour,
  isMobileFilters,
  onClickCallback,
  selectedListingFilters = [],
}: Props) => {
  const handleClick = ({ filter }: IListingFilterGroup) => {
    const id = filter.id.toString();
    const newSelectedListingFilters = selectedListingFilters.includes(id)
      ? selectedListingFilters.filter((selectedId) => selectedId !== id)
      : [...selectedListingFilters, id];

    const selectedFilterObjects = newSelectedListingFilters
      .slice() // Create a copy of the array to avoid mutating the original
      .reverse() // Reverse the array to ensure the last item is processed first
      .map((selectedId) => {
        const selectedFilter = filters.find(
          ({ filter }) => filter.id.toString() === selectedId,
        );
        return selectedFilter
          ? {
              filter: {
                id: selectedFilter.filter.id.toString(),
                label: selectedFilter.filter.label,
              },
              featuredInspiration: selectedFilter.featuredInspiration,
              inspirationCard: selectedFilter.inspirationCard,
            }
          : null;
      })
      .filter((filter) => filter !== null) as IListingFilterGroup[];

    window.dataLayer.push({
      event: 'trackingEvent_navigation_circle',
      event_name_variable: 'navigation_circle',
      trackingEvent_navigation_circle: {
        navigation_circle: filter.label,
        navigation_category: type,
      },
    });

    onClickCallback(selectedFilterObjects);
  };

  return (
    <section className="tw-w-full tw-bg-transparent tw-text-black">
      <div className="tw-flex tw-h-full tw-w-full tw-justify-center tw-overflow-hidden">
        <div className="tw-no-scrollbar tw-relative tw-select-none tw-snap-x tw-snap-proximity tw-overflow-x-auto tw-whitespace-nowrap">
          <div
            className={classNames(
              'tw-flex tw-items-start tw-text-wrap tw-px-xs md:tw-px-xl',
              type === ListingTypeEnum.Product
                ? 'tw-gap-xs md:tw-gap-sm xl:tw-gap-md'
                : 'tw-gap-xs xl:tw-gap-lg',
              isMobileFilters ? 'tw-gap-sm' : '',
            )}
          >
            {filters.map(({ colourHexCode, image, filter }) => (
              <button
                key={filter.id}
                onClick={() => handleClick({ filter })}
                className="tw-group tw-outline-none"
              >
                <ListingFilterItem
                  isMobileFilters={isMobileFilters}
                  colourHexCode={colourHexCode}
                  image={image}
                  filter={filter}
                  selected={selectedListingFilters.includes(
                    filter.id.toString(),
                  )}
                />
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ListingFilters;
